import { apiClient } from '~/api/client';
import { CompanyORLoanOfficerJSONAPI } from '~/sections/dashboard/types';
import { LoanTransactionsMetaItem } from '~/sections/loan-officers/profile/financial-performance/types';

type IndexParams = {
  period: number;
  value?: string[];
  block: string;
  limit?: number;
  page?: number;
};

type IndexResponse = {
  transactions_data: LoanOfficerResponse;
};

type LoanOfficerResponse = {
  data: CompanyORLoanOfficerJSONAPI[];
  meta: HistogramAndTotalVolume;
};

type HistogramAndTotalVolume = {
  histogram?: LoansAndTransactions;
  total_volume?: number;
  total_count?: number;
};

type LoansAndTransactions = {
  purchase?: LoanTransactionsMetaItem[];
  refinance?: LoanTransactionsMetaItem[];
  construction?: LoanTransactionsMetaItem[];
  heloc?: LoanTransactionsMetaItem[];
  va?: LoanTransactionsMetaItem[];
  fha?: LoanTransactionsMetaItem[];
  cnv?: LoanTransactionsMetaItem[];
  pp?: LoanTransactionsMetaItem[];
  sba?: LoanTransactionsMetaItem[];
  rev?: LoanTransactionsMetaItem[];
  other?: LoanTransactionsMetaItem[];
};

export const index = async (params: IndexParams) =>
  apiClient.get<IndexResponse>(`/dashboard/loan_transactions`, { params });
